import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Button, Modal } from '@telus-uds/components-web';

import { StatusBarWrapper } from '../design/statusBar/css';
import { BoxWrapper } from './css';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import stringInterpolation from '../utils/stringInterpolation';
import request from '../utils/request';

const FormButtons = ({
  isFormTouched,
  isLastStep,
  nextStep,
  prevStep,
  saveAndExit,
  showSave,
  showSubmit,
  isSalesSupport,
  orderData,
  formName,
  isSubmitting
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    formButtons: {
      submitButtonLabel,
      continueButtonLabel,
      saveContinueLaterButtonLabel,
      deleteOrder,
      createNewOrder,
      backButtonLabel,
      submittingButtonLabel
    },
    summaryForm: { modalBody, modalClose },
    headerLinks: { labelLogDefect }
  } = localizedStrings;
  const [isModalOpen, setModalOpen] = useState(false);
  const history = useHistory();

  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <BoxWrapper>
          {isSalesSupport && formName !== labelLogDefect && isLastStep ? (
            <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              <Button
                type="button"
                onPress={() => {
                  if (orderData && orderData.id) {
                    request
                      .delete(`/orders/${orderData.id}/delete-order`)
                      .then(() => {
                        setModalOpen(true);
                      });
                  }
                }}
                variant={{ priority: 'high', semantic: 'danger' }}
              >
                {deleteOrder}
              </Button>
              <Button
                type="button"
                onPress={() => history.push('/')}
                variant={{ priority: 'high' }}
              >
                {createNewOrder}
              </Button>
              <Modal
                isOpen={isModalOpen}
                onClose={() => {
                  setModalOpen(false);
                  history.push('/');
                }}
                title=""
              >
                <p>{stringInterpolation(
                  modalBody,
                  orderData && orderData.orderId
                )}</p>
                <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
                  <Button
                    type="button"
                    variant={{ priority: 'high' }}
                    onPress={() => {
                      setModalOpen(false);
                      history.push('/');
                    }}
                  >
                    {modalClose}
                  </Button>
                </div>
              </Modal>
            </div>
          ) : (
            <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              <Button
                type="button"
                onPress={prevStep}
                variant={{ priority: 'low' }}
              >
                {backButtonLabel}
              </Button>
              {showSave && !isLastStep && (
                <Button
                  type="button"
                  onPress={saveAndExit}
                  variant={{ priority: 'low' }}
                  disabled={!isFormTouched}
                >
                  {saveContinueLaterButtonLabel}
                </Button>
              )}
              {showSubmit && (
                <Button
                  type="button"
                  onPress={e => nextStep(e)}
                  variant={{ priority: 'high' }}
                  disabled={isSubmitting}
                >
                  {/* eslint-disable-next-line no-nested-ternary */}
                  {isSubmitting ? submittingButtonLabel : isLastStep ? submitButtonLabel : continueButtonLabel}
                </Button>
              )}
            </div>
          )}
        </BoxWrapper>
      </div>
    </StatusBarWrapper>
  );
};

FormButtons.propTypes = {
  isFormTouched: PropTypes.bool.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  saveAndExit: PropTypes.func.isRequired,
  showSave: PropTypes.bool,
  showSubmit: PropTypes.bool,
  isSalesSupport: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool,
  orderData: PropTypes.shape({
    id: PropTypes.number,
    orderId: PropTypes.string
  }).isRequired,
  formName: PropTypes.string.isRequired
};

FormButtons.defaultProps = {
  showSave: true,
  showSubmit: true,
  isSubmitting: false
};

export default FormButtons;
